module.exports = __webpack_public_path__ + "static/media/unselected_marker_freshwater.9af46dd3.svg";